import axiosInstance from './axiosInstance';

const normalizeList = (data, key) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data[key])) return data[key];
  if (data && Array.isArray(data.data)) return data.data;
  return [];
};

const mapCityDeliveryFromApi = (r) => {
  if (!r) return null;
  const id =
    r.id ??
    r.city_delivery_id ??
    r.cityDeliveryId ??
    r.citydelivery_id ??
    r.cityDeliveryID ??
    r.city_deliveryID ??
    r.city_deliveryId;
  return {
    id,
    cityname: r.cityname ?? r.city_name ?? r.cityName ?? '',
    pincode: String(r.pincode ?? '').trim(),
    delivery_charge: Number(r.delivery_charge ?? r.deliveryCharge ?? 0),
    is_active:
      r.is_active !== undefined
        ? Boolean(r.is_active)
        : r.status !== undefined
          ? String(r.status).toLowerCase() === 'active'
          : true,
    created_at: r.created_at ?? r.createdAt,
    updated_at: r.updated_at ?? r.updatedAt,
    raw: r,
  };
};

const tryPaths = ['/city-deliveries', '/cityDelivery', '/city-delivery', '/pincode-delivery-charges'];

const request = async (method, path, body) => {
  let lastErr = null;
  for (const base of tryPaths) {
    try {
      const res = await axiosInstance.request({
        method,
        url: `${base}${path}`,
        data: body,
      });
      return res;
    } catch (e) {
      lastErr = e;
      if (e?.response?.status === 404) continue;
      throw e;
    }
  }
  throw lastErr;
};

export const fetchCityDeliveryCharges = async () => {
  const res = await request('get', '', undefined);
  const list =
    normalizeList(res.data, 'data') ||
    normalizeList(res.data, 'cityDeliveries') ||
    normalizeList(res.data, 'city_deliveries') ||
    [];
  return list.map(mapCityDeliveryFromApi).filter(Boolean);
};

export const createCityDeliveryCharge = async ({ cityname, pincode, delivery_charge }) => {
  const res = await request('post', '', { cityname, pincode, delivery_charge });
  const row = res.data?.data ?? res.data?.cityDelivery ?? res.data;
  return mapCityDeliveryFromApi(row);
};

export const updateCityDeliveryCharge = async (id, { cityname, pincode, delivery_charge }) => {
  const res = await request('put', `/${id}`, { cityname, pincode, delivery_charge });
  const row = res.data?.data ?? res.data?.cityDelivery ?? res.data;
  return mapCityDeliveryFromApi(row) || true;
};

export const deleteCityDeliveryCharge = async (id) => {
  const res = await request('delete', `/${id}`, undefined);
  return res.data ?? true;
};

export const toggleCityDeliveryChargeStatus = async (id, nextIsActive) => {
  const payload =
    nextIsActive === undefined ? undefined : { is_active: Boolean(nextIsActive) };
  const res = await request('patch', `/${id}/toggle-status`, payload);
  const row = res.data?.data ?? res.data?.cityDelivery ?? res.data;
  return mapCityDeliveryFromApi(row) || true;
};

